(() => {
  const AI_REQUEST_TIMEOUT_MS = 65000;

  const QUESTIONS = [
    {
      id: 'homeType',
      title: 'Which best describes the place where your future pet would live most of the time?',
      answers: [
        { label: 'Small apartment or studio', value: 'small_apartment' },
        { label: 'Apartment with a bit more room', value: 'apartment' },
        { label: 'Townhouse or duplex', value: 'townhouse' },
        { label: 'House with a small yard', value: 'small_yard' },
        { label: 'House with a large secure yard', value: 'large_yard' },
        { label: 'Rural property, farm, or acreage', value: 'farm' },
        { label: 'Shared housing / roommates', value: 'shared' },
        { label: 'Student housing or temporary accommodation', value: 'student' }
      ]
    },
    {
      id: 'housingStability',
      title: 'How stable is your living situation over the next 1–3 years?',
      answers: [
        { label: 'Very stable — I do not expect major changes', value: 'very_stable' },
        { label: 'Mostly stable, with a few possible changes', value: 'mostly_stable' },
        { label: 'I may move or change homes', value: 'might_move' },
        { label: 'My housing depends on landlord / family approval', value: 'approval_needed' },
        { label: 'Honestly, it feels uncertain right now', value: 'uncertain' }
      ]
    },
    {
      id: 'outdoorAccess',
      title: 'What kind of safe outdoor access would your pet realistically have?',
      answers: [
        { label: 'None — it would be fully indoors', value: 'none' },
        { label: 'Balcony or small enclosed outdoor area', value: 'balcony' },
        { label: 'Short supervised outdoor access only', value: 'supervised_only' },
        { label: 'Small secure yard', value: 'small_secure' },
        { label: 'Large secure yard', value: 'large_secure' },
        { label: 'Open land / farm / large outdoor property', value: 'farm' }
      ]
    },
    {
      id: 'dailyTime',
      title: 'On an average day, how much real attention could you give a pet?',
      answers: [
        { label: 'Less than 15 minutes', value: 'lt15' },
        { label: '15–30 minutes', value: '15_30' },
        { label: '30–60 minutes', value: '30_60' },
        { label: '1–2 hours', value: '1_2' },
        { label: '2–4 hours', value: '2_4' },
        { label: 'A lot — pets would be a major part of my routine', value: '4_plus' }
      ]
    },
    {
      id: 'aloneTime',
      title: 'How long would a pet usually need to cope without you on a normal day?',
      answers: [
        { label: 'Almost never alone — someone is usually home', value: 'rarely_alone' },
        { label: 'A few hours', value: '3_5' },
        { label: 'A standard workday', value: '6_8' },
        { label: 'Long days are common', value: '9_12' },
        { label: 'My schedule is very unpredictable', value: 'variable' },
        { label: 'I travel often or stay away overnight', value: 'travel' }
      ]
    },
    {
      id: 'energyMatch',
      title: 'What kind of energy do you want your ideal pet to have?',
      answers: [
        { label: 'Very calm and low-key', value: 'very_calm' },
        { label: 'Relaxed, with occasional play', value: 'calm_playful' },
        { label: 'Balanced — playful but manageable', value: 'balanced' },
        { label: 'Active and always up for something', value: 'active' },
        { label: 'Very driven, athletic, or working-type', value: 'working' }
      ]
    },
    {
      id: 'activityLifestyle',
      title: 'Which option sounds most like your lifestyle?',
      answers: [
        { label: 'Homebody — I like peace, comfort, and low stimulation', value: 'homebody' },
        { label: 'I enjoy short walks and relaxed routines', value: 'short_walks' },
        { label: 'I am reasonably active and like daily movement', value: 'daily_walks' },
        { label: 'I love long walks, hikes, running, or outdoor weekends', value: 'very_active' },
        { label: 'I specifically want a pet to train, work with, or do activities with', value: 'training_lifestyle' }
      ]
    },
    {
      id: 'budget',
      title: 'What monthly pet budget would feel comfortable, not stressful?',
      answers: [
        { label: 'Very tight budget', value: 'very_limited' },
        { label: 'Basic essentials only', value: 'basic' },
        { label: 'Comfortable for food and routine care', value: 'moderate' },
        { label: 'Comfortable including grooming / extras', value: 'high' },
        { label: 'I am prepared for premium care and services', value: 'premium' }
      ]
    },
    {
      id: 'emergencyVet',
      title: 'If an unexpected vet issue happened, what would that feel like financially?',
      answers: [
        { label: 'Manageable', value: 'yes' },
        { label: 'Doable, but stressful', value: 'maybe' },
        { label: 'Very hard for me right now', value: 'no' },
        { label: 'I would rely on insurance / payment plans', value: 'insurance' }
      ]
    },
    {
      id: 'household',
      title: 'Who else would need to comfortably live with this pet?',
      answers: [
        { label: 'Just adults', value: 'adults' },
        { label: 'Babies or toddlers', value: 'toddlers' },
        { label: 'Young children', value: 'children' },
        { label: 'Teenagers', value: 'teens' },
        { label: 'Older adults / seniors', value: 'elderly' },
        { label: 'Someone with reduced mobility or special support needs', value: 'mobility' },
        { label: 'A mixed household', value: 'mixed' }
      ]
    },
    {
      id: 'existingPets',
      title: 'What other animals are already part of your life?',
      answers: [
        { label: 'No pets yet', value: 'none' },
        { label: 'One or more dogs', value: 'dog' },
        { label: 'One or more cats', value: 'cat' },
        { label: 'Both dogs and cats', value: 'dogs_cats' },
        { label: 'Birds', value: 'birds' },
        { label: 'Small pets like rabbits or guinea pigs', value: 'small_pets' },
        { label: 'Reptiles / exotic pets', value: 'reptiles' },
        { label: 'Farm or outdoor animals', value: 'farm_animals' },
        { label: 'A bit of everything', value: 'mixed' }
      ]
    },
    {
      id: 'allergies',
      title: 'Do allergies or sensitivities matter in your home?',
      answers: [
        { label: 'No, not really', value: 'no' },
        { label: 'Mild dog allergy in the household', value: 'dog_mild' },
        { label: 'Mild cat allergy in the household', value: 'cat_mild' },
        { label: 'We have stronger allergy concerns', value: 'severe' },
        { label: 'Not sure yet', value: 'not_sure' }
      ]
    },
    {
      id: 'messTolerance',
      title: 'How much mess, shedding, smell, and cleaning can you realistically tolerate?',
      answers: [
        { label: 'Very little — I want things neat and easy', value: 'very_little' },
        { label: 'A moderate amount is fine', value: 'some' },
        { label: 'Hair, litter, muddy paws, or cleaning do not scare me', value: 'high' },
        { label: 'I can handle full pet chaos if the match is right', value: 'chaos' }
      ]
    },
    {
      id: 'noiseTolerance',
      title: 'How much noise can your home and neighbours realistically handle?',
      answers: [
        { label: 'Very quiet only', value: 'very_quiet' },
        { label: 'Some noise is okay', value: 'some' },
        { label: 'Occasional barking, meowing, or chirping is fine', value: 'okay' },
        { label: 'Noise does not really matter here', value: 'fine' },
        { label: 'We have strict noise limitations', value: 'restricted' }
      ]
    },
    {
      id: 'groomingTolerance',
      title: 'How do you feel about grooming, maintenance, and routine care tasks?',
      answers: [
        { label: 'I want something low-maintenance', value: 'low_maintenance' },
        { label: 'Basic brushing / cleaning is fine', value: 'basic_maintenance' },
        { label: 'I can manage regular grooming and upkeep', value: 'regular_maintenance' },
        { label: 'I do not mind high-maintenance care if the pet is worth it', value: 'high_maintenance' }
      ]
    },
    {
      id: 'trainingConfidence',
      title: 'How confident are you with behaviour, boundaries, and training?',
      answers: [
        { label: 'Not confident at all', value: 'not_confident' },
        { label: 'Beginner, but willing to learn', value: 'beginner' },
        { label: 'Some practical experience', value: 'some' },
        { label: 'Confident and consistent', value: 'confident' },
        { label: 'Very experienced', value: 'very_experienced' },
        { label: 'I actively want a challenge', value: 'challenge' }
      ]
    },
    {
      id: 'bondStyle',
      title: 'What kind of relationship do you want with your future pet?',
      answers: [
        { label: 'Very affectionate and cuddly', value: 'cuddly' },
        { label: 'Close, but not clingy', value: 'balanced_bond' },
        { label: 'More independent and low-pressure', value: 'independent' },
        { label: 'Family-oriented and social', value: 'family' },
        { label: 'Activity partner / adventure companion', value: 'exercise' },
        { label: 'Trainable and mentally engaging', value: 'training' },
        { label: 'Calming emotional presence', value: 'support' },
        { label: 'Beautiful, interesting, and enjoyable to observe', value: 'quiet' }
      ]
    },
    {
      id: 'stressMost',
      title: 'Which part of pet ownership would be hardest for you to deal with consistently?',
      answers: [
        { label: 'Unexpected vet costs', value: 'vet_bills' },
        { label: 'Noise / barking / vocal behaviour', value: 'noise' },
        { label: 'Hair, smell, litter, or mess', value: 'mess' },
        { label: 'Toilet accidents or house training', value: 'toilet_training' },
        { label: 'Behaviour or training problems', value: 'behaviour' },
        { label: 'Daily exercise demands', value: 'exercise' },
        { label: 'Cleaning cages, tanks, or habitats', value: 'cage_cleaning' },
        { label: 'Scratching, chewing, or property damage', value: 'damage' },
        { label: 'Long-term time commitment', value: 'time' },
        { label: 'Honestly, I feel ready for almost anything', value: 'ready' }
      ]
    }
  ];

  const RESULT_META = {
    adult_cat: {
      label: 'Adult Cat',
      productType: 'cat',
      species: 'cat'
    },
    kitten: {
      label: 'Kitten',
      productType: 'cat',
      species: 'cat'
    },
    small_dog: {
      label: 'Small Adult Dog',
      productType: 'dog',
      species: 'dog'
    },
    family_dog: {
      label: 'Family Dog',
      productType: 'dog',
      species: 'dog'
    },
    active_dog: {
      label: 'Active Dog',
      productType: 'dog',
      species: 'dog'
    },
    puppy: {
      label: 'Puppy',
      productType: 'dog',
      species: 'dog'
    },
    small_pet: {
      label: 'Rabbit or Guinea Pig',
      productType: 'other',
      species: 'small_pet'
    },
    bird_reptile_fish: {
      label: 'Bird, Reptile, or Fish',
      productType: 'other',
      species: 'other'
    },
    foster_first: {
      label: 'Foster First',
      productType: 'other',
      species: 'other'
    },
    not_yet: {
      label: 'Not Yet',
      productType: 'other',
      species: 'other'
    }
  };

  class SPerfectPetPicker extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      this.activeRequestController = null;

      this.state = {
        currentIndex: 0,
        answers: {},
        resultKey: null,
        isLoading: false
      };

      this.stepWelcome = this.querySelector('[data-step="welcome"]');
      this.stepQuiz = this.querySelector('[data-step="quiz"]');

      this.startButton = this.querySelector('[data-start-quiz]');
      this.backButton = this.querySelector('[data-go-back]');
      this.progressLabel = this.querySelector('[data-progress-label]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.questionTitle = this.querySelector('[data-question-title]');
      this.answersWrap = this.querySelector('[data-question-answers]');
      this.loadingState = this.querySelector('[data-loading-state]');
      this.editAnswersButton = this.querySelector('[data-edit-answers]');
      this.restartQuizButton = this.querySelector('[data-restart-quiz]');

      this.modal = this.querySelector('[data-result-modal]');
      this.closeButtons = Array.from(
        this.querySelectorAll('[data-close-modal]')
      );
      this.copyResultLinkButton = this.querySelector(
        '[data-copy-result-link]'
      );

      this.resultTitle = this.querySelector('[data-result-title]');
      this.resultSummary = this.querySelector('[data-result-summary]');
      this.resultScore = this.querySelector('[data-result-score]');
      this.resultScoreLabel = this.querySelector(
        '[data-result-score-label]'
      );
      this.resultWhy = this.querySelector('[data-result-why]');
      this.resultPrepare = this.querySelector('[data-result-prepare]');
      this.resultAvoid = this.querySelector('[data-result-avoid]');
      this.resultAlso = this.querySelector('[data-result-also]');
      this.resultAppText = this.querySelector('[data-result-app-text]');
      this.resultAppFeatures = this.querySelector(
        '[data-result-app-features]'
      );
      this.resultPrimaryCta = this.querySelector(
        '[data-result-primary-cta]'
      );
      this.productsCard = this.querySelector('[data-products-card]');
      this.productsText = this.querySelector('[data-products-text]');
      this.productsLink = this.querySelector('[data-products-link]');

      this.dogBreedsData = {};
      this.catBreedsData = {};

      this.onKeydown = this.onKeydown.bind(this);
      this.handleStartQuiz = this.handleStartQuiz.bind(this);
      this.handleGoBack = this.handleGoBack.bind(this);
      this.handleCopyResultLink = this.handleCopyResultLink.bind(this);
      this.handleEditAnswers = this.handleEditAnswers.bind(this);
      this.handleRestartQuiz = this.handleRestartQuiz.bind(this);
      this.handleCloseModal = this.handleCloseModal.bind(this);

      this.startButton?.addEventListener(
        'click',
        this.handleStartQuiz
      );

      this.backButton?.addEventListener(
        'click',
        this.handleGoBack
      );

      this.copyResultLinkButton?.addEventListener(
        'click',
        this.handleCopyResultLink
      );

      this.editAnswersButton?.addEventListener(
        'click',
        this.handleEditAnswers
      );

      this.restartQuizButton?.addEventListener(
        'click',
        this.handleRestartQuiz
      );

      this.closeButtons.forEach((button) => {
        button.addEventListener(
          'click',
          this.handleCloseModal
        );
      });

      this.setLoading(false);
      this.loadAllBreeds();
    }

    disconnectedCallback() {
      document.removeEventListener(
        'keydown',
        this.onKeydown
      );

      this.abortActiveRequest();

      this.startButton?.removeEventListener(
        'click',
        this.handleStartQuiz
      );

      this.backButton?.removeEventListener(
        'click',
        this.handleGoBack
      );

      this.copyResultLinkButton?.removeEventListener(
        'click',
        this.handleCopyResultLink
      );

      this.editAnswersButton?.removeEventListener(
        'click',
        this.handleEditAnswers
      );

      this.restartQuizButton?.removeEventListener(
        'click',
        this.handleRestartQuiz
      );

      this.closeButtons?.forEach((button) => {
        button.removeEventListener(
          'click',
          this.handleCloseModal
        );
      });

      this.isInitialized = false;
    }

    handleStartQuiz() {
      this.startQuiz();
    }

    handleGoBack() {
      this.goBack();
    }

    handleCopyResultLink() {
      this.copyResultLink();
    }

    handleEditAnswers() {
      this.goBackToAnswers();
    }

    handleRestartQuiz() {
      this.restartQuiz();
    }

    handleCloseModal() {
      this.closeModal({
        resetUrl: true
      });
    }

    abortActiveRequest() {
      if (!this.activeRequestController) return;

      try {
        this.activeRequestController.abort();
      } catch (error) {
        console.warn(
          '[Perfect Pet Picker] Could not abort active request:',
          error
        );
      }

      this.activeRequestController = null;
    }

    async loadAllBreeds() {
      const [
        dogBreeds,
        catBreeds
      ] = await Promise.all([
        this.loadBreeds(
          this.dataset.dogBreedsUrl
        ),
        this.loadBreeds(
          this.dataset.catBreedsUrl
        )
      ]);

      this.dogBreedsData = dogBreeds || {};
      this.catBreedsData = catBreeds || {};
    }

    async loadBreeds(url) {
      if (!url) return {};

      try {
        const response = await fetch(url, {
          cache: 'force-cache'
        });

        if (!response.ok) {
          throw new Error(
            `HTTP ${response.status}`
          );
        }

        return await response.json();
      } catch (error) {
        console.warn(
          '[Perfect Pet Picker] Could not load breeds JSON:',
          error
        );

        return {};
      }
    }

    setLoading(isLoading) {
      this.state.isLoading = Boolean(isLoading);

      this.classList.toggle(
        'is-loading',
        this.state.isLoading
      );

      if (this.loadingState) {
        this.loadingState.hidden =
          !this.state.isLoading;
      }

      if (this.answersWrap) {
        this.answersWrap.hidden =
          this.state.isLoading;
      }

      if (this.backButton) {
        this.backButton.disabled =
          this.state.isLoading;
      }
    }

    startQuiz() {
      this.abortActiveRequest();

      this.setVisibleStep('quiz');
      this.setLoading(false);
      this.renderQuestion();

      this.trackEvent('quiz_started');
    }

    setVisibleStep(step) {
      const map = {
        welcome: this.stepWelcome,
        quiz: this.stepQuiz
      };

      Object.entries(map).forEach(
        ([key, node]) => {
          if (!node) return;

          node.hidden = key !== step;
        }
      );
    }

    renderQuestion() {
      const question =
        QUESTIONS[this.state.currentIndex];

      if (!question) {
        this.trackEvent(
          'quiz_completed',
          {
            answers: this.state.answers
          }
        );

        this.showResult();
        return;
      }

      this.setLoading(false);

      if (this.questionTitle) {
        this.questionTitle.textContent =
          question.title;
      }

      if (this.progressLabel) {
        this.progressLabel.textContent =
          `Question ${this.state.currentIndex + 1} of ${QUESTIONS.length}`;
      }

      if (this.progressBar) {
        this.progressBar.style.width =
          `${((this.state.currentIndex + 1) / QUESTIONS.length) * 100}%`;
      }

      if (this.backButton) {
        this.backButton.hidden =
          this.state.currentIndex === 0;

        this.backButton.disabled = false;
      }

      const currentValue =
        this.state.answers[question.id];

      if (!this.answersWrap) return;

      this.answersWrap.innerHTML =
        question.answers
          .map((answer) => {
            const activeClass =
              currentValue === answer.value
                ? ' is-active'
                : '';

            return `
              <button
                type="button"
                class="perfect-pet-picker__answer${activeClass}"
                data-answer-value="${this.escapeHtml(answer.value)}"
              >
                ${this.escapeHtml(answer.label)}
              </button>
            `;
          })
          .join('');

      this.answersWrap
        .querySelectorAll(
          '[data-answer-value]'
        )
        .forEach((button) => {
          button.addEventListener(
            'click',
            () => {
              this.answerQuestion(
                question.id,
                button.dataset.answerValue
              );
            }
          );
        });
    }

    answerQuestion(questionId, value) {
      if (this.state.isLoading) return;

      this.state.answers[questionId] =
        value;

      this.trackEvent(
        'quiz_question_answered',
        {
          questionId,
          value,
          step:
            this.state.currentIndex + 1
        }
      );

      this.state.currentIndex += 1;

      this.renderQuestion();
    }

    goBack() {
      if (this.state.isLoading) return;
      if (this.state.currentIndex <= 0) return;

      this.state.currentIndex -= 1;

      this.renderQuestion();
    }

    async getAiResult() {
      const endpoint =
        this.dataset.aiEndpoint ||
        'https://api.askavet.workers.dev/result';

      this.abortActiveRequest();

      const controller =
        new AbortController();

      this.activeRequestController =
        controller;

      const timeoutId =
        window.setTimeout(() => {
          controller.abort();
        }, AI_REQUEST_TIMEOUT_MS);

      let response;

      try {
        response = await fetch(
          endpoint,
          {
            method: 'POST',
            signal: controller.signal,
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body: JSON.stringify({
              answers:
                this.state.answers
            })
          }
        );
      } catch (error) {
        if (
          error?.name ===
          'AbortError'
        ) {
          console.warn(
            '[Perfect Pet Picker] AI request timed out or was aborted:',
            {
              endpoint,
              timeoutMs:
                AI_REQUEST_TIMEOUT_MS
            }
          );

          throw new Error(
            'AI request timed out'
          );
        }

        console.error(
          '[Perfect Pet Picker] Network request failed:',
          {
            endpoint,
            error
          }
        );

        throw new Error(
          error instanceof Error
            ? `Could not reach the AI endpoint: ${error.message}`
            : 'Could not reach the AI endpoint'
        );
      } finally {
        window.clearTimeout(
          timeoutId
        );

        if (
          this.activeRequestController ===
          controller
        ) {
          this.activeRequestController =
            null;
        }
      }

      const responseText =
        await response.text();

      let data = null;

      if (responseText) {
        try {
          data =
            JSON.parse(responseText);
        } catch (error) {
          console.error(
            '[Perfect Pet Picker] API returned invalid JSON:',
            {
              endpoint,
              status:
                response.status,
              statusText:
                response.statusText,
              responseText,
              parseError:
                error
            }
          );
        }
      }

      if (!response.ok) {
        const upstreamDetails =
          typeof data?.details ===
          'string'
            ? data.details
            : data?.details
              ? JSON.stringify(
                  data.details
                )
              : '';

        const message =
          upstreamDetails ||
          data?.error ||
          responseText ||
          `AI endpoint failed with status ${response.status}`;

        console.error(
          '[Perfect Pet Picker] API request failed:',
          {
            endpoint,
            status:
              response.status,
            statusText:
              response.statusText,
            upstreamStatus:
              data?.upstreamStatus,
            error:
              data?.error,
            details:
              data?.details,
            response:
              data || responseText
          }
        );

        throw new Error(
          message
        );
      }

      if (
        !data ||
        typeof data !== 'object'
      ) {
        console.error(
          '[Perfect Pet Picker] Empty or invalid API response:',
          {
            endpoint,
            status:
              response.status,
            responseText
          }
        );

        throw new Error(
          'The AI endpoint returned an invalid response'
        );
      }

      if (
        !data.ok ||
        !data.result
      ) {
        console.error(
          '[Perfect Pet Picker] API response did not contain a result:',
          data
        );

        throw new Error(
          data.error ||
          'The AI endpoint returned no result'
        );
      }

      return this.normalizeAiResult(
        data.result
      );
    }

    normalizeAiResult(rawResult) {
      if (
        !rawResult ||
        typeof rawResult !== 'object'
      ) {
        throw new Error(
          'AI result is not an object'
        );
      }

      const allowedResultKeys =
        Object.keys(
          RESULT_META
        );

      const resultKey =
        allowedResultKeys.includes(
          rawResult.resultKey
        )
          ? rawResult.resultKey
          : null;

      if (!resultKey) {
        console.error(
          '[Perfect Pet Picker] Unknown result key:',
          rawResult.resultKey
        );

        throw new Error(
          `Unknown AI result key: ${rawResult.resultKey}`
        );
      }

      const meta =
        RESULT_META[resultKey];

      const why =
        this.normalizeStringArray(
          rawResult.why,
          4,
          4
        );

      const prepare =
        this.normalizeStringArray(
          rawResult.prepare,
          4,
          4
        );

      const appFeatures =
        this.normalizeStringArray(
          rawResult.appFeatures,
          4,
          6
        );

      if (why.length < 4) {
        throw new Error(
          'AI result must contain four "why" items'
        );
      }

      if (prepare.length < 4) {
        throw new Error(
          'AI result must contain four "prepare" items'
        );
      }

      if (
        appFeatures.length < 4
      ) {
        throw new Error(
          'AI result must contain at least four app features'
        );
      }

      const parsedScore =
        Number(
          rawResult.matchScore
        );

      const matchScore =
        Number.isFinite(
          parsedScore
        )
          ? Math.max(
              55,
              Math.min(
                97,
                Math.round(
                  parsedScore
                )
              )
            )
          : 70;

      const allowedProductTypes = [
        'dog',
        'cat',
        'other'
      ];

      const productType =
        allowedProductTypes.includes(
          rawResult.productType
        )
          ? rawResult.productType
          : meta.productType;

      return {
        resultKey,
        label:
          this.normalizeText(
            rawResult.label,
            meta.label
          ),
        scoreLabel:
          this.normalizeText(
            rawResult.scoreLabel,
            'Good match'
          ),
        summary:
          this.normalizeText(
            rawResult.summary,
            'This result reflects the practical fit between your lifestyle and the needs of this type of pet.'
          ),
        why,
        prepare,
        avoid:
          this.normalizeText(
            rawResult.avoid,
            this.buildAvoidForNow(
              resultKey
            )
          ),
        also:
          this.normalizeText(
            rawResult.also,
            'No strong alternative identified'
          ),
        appText:
          this.normalizeText(
            rawResult.appText,
            this.buildAppText(
              resultKey,
              meta
            )
          ),
        appFeatures,
        productType,
        matchScore
      };
    }

    normalizeText(
      value,
      fallback = ''
    ) {
      if (
        typeof value !== 'string'
      ) {
        return fallback;
      }

      const normalized =
        value.trim();

      return normalized || fallback;
    }

    normalizeStringArray(
      value,
      minimum = 0,
      maximum = Infinity
    ) {
      if (
        !Array.isArray(value)
      ) {
        return [];
      }

      const normalized =
        value
          .filter(
            (item) =>
              typeof item ===
              'string'
          )
          .map(
            (item) =>
              item.trim()
          )
          .filter(Boolean);

      const unique =
        Array.from(
          new Set(normalized)
        );

      if (
        unique.length <
        minimum
      ) {
        return unique;
      }

      return unique.slice(
        0,
        maximum
      );
    }

    async showResult() {
      if (
        this.state.isLoading
      ) {
        return;
      }

      this.setLoading(true);

      try {
        const aiResult =
          await this.getAiResult();

        this.state.resultKey =
          aiResult.resultKey;

        this.renderResult(
          aiResult,
          {
            matchScore:
              aiResult.matchScore,
            source: 'ai'
          }
        );
      } catch (error) {
        console.warn(
          '[Perfect Pet Picker] AI failed, using local fallback:',
          error
        );

        try {
          const ranking =
            this.resolveRanking();

          const best =
            ranking[0];

          const second =
            ranking[1];

          const resultKey =
            best?.key ||
            'not_yet';

          this.state.resultKey =
            resultKey;

          const result =
            this.buildResultContent(
              resultKey,
              ranking
            );

          const matchScore =
            this.calculateMatchScore(
              best?.score || 0,
              second?.score || 0,
              resultKey
            );

          this.renderResult(
            result,
            {
              matchScore,
              source:
                'local_fallback'
            }
          );
        } catch (
          fallbackError
        ) {
          console.error(
            '[Perfect Pet Picker] Local fallback failed:',
            fallbackError
          );

          const emergencyResult =
            this.buildEmergencyFallback();

          this.state.resultKey =
            emergencyResult.resultKey;

          this.renderResult(
            emergencyResult,
            {
              matchScore:
                emergencyResult.matchScore,
              source:
                'emergency_fallback'
            }
          );
        }
      } finally {
        this.setLoading(false);
      }
    }

    buildEmergencyFallback() {
      const a =
        this.state.answers;

      const severeReadinessConcern =
        a.emergencyVet === 'no' ||
        a.budget === 'very_limited' ||
        [
          'approval_needed',
          'uncertain'
        ].includes(
          a.housingStability
        );

      if (
        severeReadinessConcern
      ) {
        return {
          resultKey: 'not_yet',
          label: 'Not Yet',
          scoreLabel:
            'Needs planning',
          summary:
            'Right now may not be the easiest moment to bring a pet home. A little more preparation around time, budget, housing, or support could make future pet ownership much easier and more enjoyable.',
          why: [
            'Your answers suggest there may be a few practical areas worth strengthening before making a long-term commitment.',
            'Pet ownership works best when daily care can remain predictable even during busy or expensive periods.',
            'Thinking about emergency care, housing, and routine before adopting can prevent a stressful mismatch.',
            'Waiting until the practical pieces feel stronger can create a much better experience for both you and a future pet.'
          ],
          prepare: [
            'Build a realistic monthly pet-care budget.',
            'Make a plan for unexpected veterinary costs.',
            'Confirm that your housing and daily routine can support a pet long term.',
            'Consider fostering, volunteering, or pet sitting while you prepare.'
          ],
          avoid:
            'A puppy, active dog, or other high-maintenance commitment is probably not ideal right now.',
          also:
            'Foster First',
          appText:
            'ASK A VET™ can help you organise research, reminders, questions, and future pet planning before you commit.',
          appFeatures: [
            'Future pet planning',
            'Care research notes',
            'Reminder planning',
            'Vet questions'
          ],
          productType:
            'other',
          matchScore:
            65
        };
      }

      return {
        resultKey:
          'adult_cat',
        label:
          'Adult Cat',
        scoreLabel:
          'Good match',
        summary:
          'An adult cat may be a practical option because it can offer companionship while generally requiring less training intensity than a puppy or highly active dog.',
        why: [
          'An adult pet offers a more established personality, which can make matching easier.',
          'Cats can often adapt well to indoor living and a range of home sizes.',
          'Daily care can be structured around a predictable feeding, litter, enrichment, and health routine.',
          'An adult cat may provide companionship without the same exercise and training demands as many dogs.'
        ],
        prepare: [
          'Prepare a safe indoor setup with litter, scratching areas, resting places, and enrichment.',
          'Budget for food, preventive care, vaccinations, and unexpected veterinary needs.',
          'Plan how care will be handled during travel or changes in routine.',
          'Choose an individual cat whose temperament genuinely matches your household.'
        ],
        avoid:
          'A puppy or very high-drive working dog may require considerably more time and structure.',
        also:
          'Small Adult Dog, Foster First',
        appText:
          'ASK A VET™ can help you organise health records, reminders, behaviour notes, weight tracking, and everyday care questions.',
        appFeatures: [
          'Create cat profile',
          'Vaccination reminders',
          'Parasite reminders',
          'Weight tracking',
          'Behaviour logs'
        ],
        productType:
          'cat',
        matchScore:
          78
      };
    }

    renderResult(
      result,
      {
        matchScore,
        source
      }
    ) {
      const resultKey =
        this.state.resultKey;

      if (this.resultTitle) {
        this.resultTitle.textContent =
          `Your Perfect Pet Match: ${result.label}`;
      }

      if (this.resultSummary) {
        this.resultSummary.textContent =
          result.summary;
      }

      if (this.resultScore) {
        this.resultScore.textContent =
          `${matchScore}%`;
      }

      if (
        this.resultScoreLabel
      ) {
        this.resultScoreLabel.textContent =
          result.scoreLabel;
      }

      if (this.resultWhy) {
        this.resultWhy.innerHTML =
          this.renderListItems(
            result.why
          );
      }

      if (
        this.resultPrepare
      ) {
        this.resultPrepare.innerHTML =
          this.renderListItems(
            result.prepare
          );
      }

      if (
        this.resultAvoid
      ) {
        this.resultAvoid.textContent =
          result.avoid;
      }

      if (
        this.resultAlso
      ) {
        this.resultAlso.textContent =
          result.also;
      }

      if (
        this.resultAppText
      ) {
        this.resultAppText.textContent =
          result.appText;
      }

      if (
        this.resultAppFeatures
      ) {
        this.resultAppFeatures.innerHTML =
          this.renderListItems(
            result.appFeatures
          );
      }

      this.configurePrimaryCta();
      this.renderProducts(result);

      this.trackEvent(
        'result_viewed',
        {
          result:
            resultKey,
          score:
            matchScore,
          source
        }
      );

      this.updateUrlWithResult(
        resultKey
      );

      this.openModal();
    }

    renderListItems(items) {
      if (
        !Array.isArray(items)
      ) {
        return '';
      }

      return items
        .map(
          (item) =>
            `<li>${this.escapeHtml(item)}</li>`
        )
        .join('');
    }

    configurePrimaryCta() {
      if (
        !this.resultPrimaryCta
      ) {
        return;
      }

      const primaryLabel =
        this.dataset.primaryCtaLabel ||
        'Download ASK A VET™';

      const primaryLink =
        this.dataset.primaryCtaLink ||
        '#';

      this.resultPrimaryCta.textContent =
        primaryLabel;

      this.resultPrimaryCta.href =
        primaryLink;

      this.resultPrimaryCta.onclick =
        () => {
          this.trackEvent(
            'app_download_clicked',
            {
              result:
                this.state
                  .resultKey
            }
          );
        };
    }

    resolveRanking() {
      const a =
        this.state.answers;

      const scores = {
        adult_cat:
          this.scoreAdultCat(a),
        kitten:
          this.scoreKitten(a),
        small_dog:
          this.scoreSmallDog(a),
        family_dog:
          this.scoreFamilyDog(a),
        active_dog:
          this.scoreActiveDog(a),
        puppy:
          this.scorePuppy(a),
        small_pet:
          this.scoreSmallPet(a),
        bird_reptile_fish:
          this.scoreObservationPet(a),
        foster_first:
          this.scoreFosterFirst(a),
        not_yet:
          this.scoreNotYet(a)
      };

      return Object.entries(
        scores
      )
        .map(
          ([key, score]) => ({
            key,
            score
          })
        )
        .sort(
          (left, right) =>
            right.score -
            left.score
        );
    }

    calculateMatchScore(
      bestScore,
      secondScore,
      resultKey
    ) {
      const margin =
        Math.max(
          0,
          bestScore -
            secondScore
        );

      if (
        resultKey ===
        'not_yet'
      ) {
        return Math.max(
          58,
          Math.min(
            76,
            62 +
              margin * 2
          )
        );
      }

      if (
        resultKey ===
        'foster_first'
      ) {
        return Math.max(
          68,
          Math.min(
            84,
            72 +
              margin * 2
          )
        );
      }

      return Math.max(
        72,
        Math.min(
          96,
          78 +
            margin * 2
        )
      );
    }

    scoreAdultCat(a) {
      let score = 0;

      if (
        [
          'small_apartment',
          'apartment',
          'townhouse',
          'shared',
          'student'
        ].includes(
          a.homeType
        )
      ) {
        score += 5;
      }

      if (
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        )
      ) {
        score += 2;
      }

      if (
        [
          'none',
          'balcony',
          'supervised_only',
          'small_secure'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 4;
      }

      if (
        [
          '15_30',
          '30_60',
          '1_2'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 4;
      }

      if (
        [
          '6_8',
          '9_12',
          'variable'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 3;
      }

      if (
        [
          'very_calm',
          'calm_playful',
          'balanced'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 4;
      }

      if (
        [
          'homebody',
          'short_walks',
          'daily_walks'
        ].includes(
          a.activityLifestyle
        )
      ) {
        score += 3;
      }

      if (
        [
          'basic',
          'moderate',
          'high'
        ].includes(
          a.budget
        )
      ) {
        score += 2;
      }

      if (
        [
          'independent',
          'balanced_bond',
          'support',
          'cuddly'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 5;
      }

      if (
        [
          'very_little',
          'some'
        ].includes(
          a.messTolerance
        )
      ) {
        score += 1;
      }

      if (
        [
          'very_quiet',
          'some',
          'okay',
          'restricted'
        ].includes(
          a.noiseTolerance
        )
      ) {
        score += 2;
      }

      if (
        [
          'low_maintenance',
          'basic_maintenance',
          'regular_maintenance'
        ].includes(
          a.groomingTolerance
        )
      ) {
        score += 2;
      }

      if (
        a.allergies ===
          'cat_mild' ||
        a.allergies ===
          'severe'
      ) {
        score -= 5;
      }

      if (
        a.stressMost ===
        'toilet_training'
      ) {
        score += 2;
      }

      if (
        a.stressMost ===
        'exercise'
      ) {
        score += 2;
      }

      if (
        a.household ===
        'toddlers'
      ) {
        score -= 1;
      }

      const catSizeBias =
        this.inferCatSizePreference(
          a
        );

      if (
        catSizeBias ===
        'small'
      ) {
        score += 1;
      }

      return score;
    }

    scoreKitten(a) {
      let score =
        this.scoreAdultCat(a);

      if (
        [
          '1_2',
          '2_4',
          '4_plus'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 3;
      }

      if (
        [
          'rarely_alone',
          '3_5'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 2;
      }

      if (
        [
          'balanced',
          'active'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 2;
      }

      if (
        [
          'beginner',
          'some',
          'confident',
          'very_experienced'
        ].includes(
          a.trainingConfidence
        )
      ) {
        score += 1;
      }

      if (
        [
          'basic_maintenance',
          'regular_maintenance',
          'high_maintenance'
        ].includes(
          a.groomingTolerance
        )
      ) {
        score += 1;
      }

      if (
        a.stressMost ===
        'time'
      ) {
        score -= 3;
      }

      if (
        a.stressMost ===
        'mess'
      ) {
        score -= 2;
      }

      if (
        a.stressMost ===
        'damage'
      ) {
        score -= 2;
      }

      if (
        a.aloneTime ===
          'travel' ||
        a.aloneTime ===
          '9_12'
      ) {
        score -= 3;
      }

      return score;
    }

    scoreSmallDog(a) {
      let score = 0;

      if (
        [
          'apartment',
          'townhouse',
          'small_yard',
          'shared'
        ].includes(
          a.homeType
        )
      ) {
        score += 3;
      }

      if (
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        )
      ) {
        score += 2;
      }

      if (
        [
          'balcony',
          'supervised_only',
          'small_secure',
          'large_secure'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 3;
      }

      if (
        [
          '30_60',
          '1_2',
          '2_4'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 5;
      }

      if (
        [
          'rarely_alone',
          '3_5',
          '6_8'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 2;
      }

      if (
        [
          'calm_playful',
          'balanced',
          'active'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 3;
      }

      if (
        [
          'short_walks',
          'daily_walks'
        ].includes(
          a.activityLifestyle
        )
      ) {
        score += 4;
      }

      if (
        [
          'moderate',
          'high',
          'premium'
        ].includes(
          a.budget
        )
      ) {
        score += 4;
      }

      if (
        [
          'cuddly',
          'balanced_bond',
          'family',
          'support'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 4;
      }

      if (
        [
          'basic_maintenance',
          'regular_maintenance'
        ].includes(
          a.groomingTolerance
        )
      ) {
        score += 2;
      }

      if (
        [
          'beginner',
          'some',
          'confident'
        ].includes(
          a.trainingConfidence
        )
      ) {
        score += 3;
      }

      if (
        a.noiseTolerance ===
        'restricted'
      ) {
        score -= 3;
      }

      if (
        a.allergies ===
          'dog_mild' ||
        a.allergies ===
          'severe'
      ) {
        score -= 5;
      }

      if (
        a.stressMost ===
        'exercise'
      ) {
        score -= 3;
      }

      if (
        a.stressMost ===
        'noise'
      ) {
        score -= 2;
      }

      const dogSizeBias =
        this.inferDogSizePreference(
          a
        );

      if (
        dogSizeBias ===
        'small'
      ) {
        score += 2;
      }

      return score;
    }

    scoreFamilyDog(a) {
      let score = 0;

      if (
        [
          'townhouse',
          'small_yard',
          'large_yard'
        ].includes(
          a.homeType
        )
      ) {
        score += 4;
      }

      if (
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        )
      ) {
        score += 2;
      }

      if (
        [
          'small_secure',
          'large_secure'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 4;
      }

      if (
        [
          '1_2',
          '2_4',
          '4_plus'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 5;
      }

      if (
        [
          'rarely_alone',
          '3_5',
          '6_8'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 2;
      }

      if (
        [
          'balanced',
          'active'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 4;
      }

      if (
        [
          'daily_walks',
          'very_active'
        ].includes(
          a.activityLifestyle
        )
      ) {
        score += 3;
      }

      if (
        [
          'moderate',
          'high',
          'premium'
        ].includes(
          a.budget
        )
      ) {
        score += 4;
      }

      if (
        [
          'family',
          'cuddly',
          'balanced_bond',
          'support'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 5;
      }

      if (
        [
          'children',
          'teens',
          'mixed'
        ].includes(
          a.household
        )
      ) {
        score += 3;
      }

      if (
        [
          'beginner',
          'some',
          'confident'
        ].includes(
          a.trainingConfidence
        )
      ) {
        score += 2;
      }

      if (
        a.stressMost ===
        'exercise'
      ) {
        score -= 2;
      }

      if (
        a.stressMost ===
        'behaviour'
      ) {
        score -= 2;
      }

      if (
        a.allergies ===
          'dog_mild' ||
        a.allergies ===
          'severe'
      ) {
        score -= 5;
      }

      const dogSizeBias =
        this.inferDogSizePreference(
          a
        );

      if (
        dogSizeBias ===
        'medium'
      ) {
        score += 2;
      }

      return score;
    }

    scoreActiveDog(a) {
      let score = 0;

      if (
        [
          'large_yard',
          'farm'
        ].includes(
          a.homeType
        )
      ) {
        score += 5;
      }

      if (
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        )
      ) {
        score += 2;
      }

      if (
        [
          'large_secure',
          'farm'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 5;
      }

      if (
        [
          '1_2',
          '2_4',
          '4_plus'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 5;
      }

      if (
        [
          'rarely_alone',
          '3_5'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 2;
      }

      if (
        [
          'active',
          'working'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 6;
      }

      if (
        [
          'very_active',
          'training_lifestyle'
        ].includes(
          a.activityLifestyle
        )
      ) {
        score += 6;
      }

      if (
        [
          'high',
          'premium'
        ].includes(
          a.budget
        )
      ) {
        score += 3;
      }

      if (
        [
          'exercise',
          'training'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 6;
      }

      if (
        [
          'confident',
          'very_experienced',
          'challenge'
        ].includes(
          a.trainingConfidence
        )
      ) {
        score += 4;
      }

      if (
        a.stressMost ===
          'exercise' ||
        a.stressMost ===
          'time'
      ) {
        score -= 6;
      }

      if (
        a.noiseTolerance ===
        'restricted'
      ) {
        score -= 2;
      }

      if (
        a.allergies ===
          'dog_mild' ||
        a.allergies ===
          'severe'
      ) {
        score -= 5;
      }

      const dogSizeBias =
        this.inferDogSizePreference(
          a
        );

      if (
        dogSizeBias ===
          'large' ||
        dogSizeBias ===
          'extra_large'
      ) {
        score += 2;
      }

      return score;
    }

    scorePuppy(a) {
      let score = 0;

      if (
        [
          'townhouse',
          'small_yard',
          'large_yard'
        ].includes(
          a.homeType
        )
      ) {
        score += 3;
      }

      if (
        a.homeType ===
        'farm'
      ) {
        score += 1;
      }

      if (
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        )
      ) {
        score += 3;
      }

      if (
        [
          'small_secure',
          'large_secure',
          'farm'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 3;
      }

      if (
        [
          '1_2',
          '2_4',
          '4_plus'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 6;
      }

      if (
        [
          'rarely_alone',
          '3_5'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 4;
      }

      if (
        [
          'balanced',
          'active'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 2;
      }

      if (
        [
          'moderate',
          'high',
          'premium'
        ].includes(
          a.budget
        )
      ) {
        score += 4;
      }

      if (
        [
          'cuddly',
          'family',
          'training',
          'exercise'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 3;
      }

      if (
        [
          'some',
          'confident',
          'very_experienced',
          'challenge'
        ].includes(
          a.trainingConfidence
        )
      ) {
        score += 4;
      }

      if (
        [
          'basic_maintenance',
          'regular_maintenance',
          'high_maintenance'
        ].includes(
          a.groomingTolerance
        )
      ) {
        score += 1;
      }

      if (
        a.stressMost ===
        'toilet_training'
      ) {
        score -= 5;
      }

      if (
        a.stressMost ===
        'time'
      ) {
        score -= 5;
      }

      if (
        a.stressMost ===
        'damage'
      ) {
        score -= 3;
      }

      if (
        a.aloneTime ===
          '9_12' ||
        a.aloneTime ===
          'travel'
      ) {
        score -= 6;
      }

      if (
        a.allergies ===
          'dog_mild' ||
        a.allergies ===
          'severe'
      ) {
        score -= 5;
      }

      return score;
    }

    scoreSmallPet(a) {
      let score = 0;

      if (
        [
          'small_apartment',
          'apartment',
          'townhouse',
          'shared',
          'student'
        ].includes(
          a.homeType
        )
      ) {
        score += 3;
      }

      if (
        [
          'mostly_stable',
          'very_stable'
        ].includes(
          a.housingStability
        )
      ) {
        score += 1;
      }

      if (
        [
          'none',
          'balcony',
          'supervised_only'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 1;
      }

      if (
        [
          '15_30',
          '30_60',
          '1_2'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 3;
      }

      if (
        [
          '3_5',
          '6_8',
          '9_12'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 1;
      }

      if (
        [
          'very_calm',
          'calm_playful',
          'balanced'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 2;
      }

      if (
        [
          'homebody',
          'short_walks'
        ].includes(
          a.activityLifestyle
        )
      ) {
        score += 2;
      }

      if (
        [
          'basic',
          'moderate',
          'high'
        ].includes(
          a.budget
        )
      ) {
        score += 2;
      }

      if (
        [
          'independent',
          'quiet',
          'balanced_bond'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 3;
      }

      if (
        [
          'basic_maintenance',
          'regular_maintenance'
        ].includes(
          a.groomingTolerance
        )
      ) {
        score += 2;
      }

      if (
        a.stressMost ===
        'exercise'
      ) {
        score += 2;
      }

      if (
        a.stressMost ===
        'cage_cleaning'
      ) {
        score -= 5;
      }

      if (
        a.household ===
        'toddlers'
      ) {
        score -= 2;
      }

      return score;
    }

    scoreObservationPet(a) {
      let score = 0;

      if (
        [
          'small_apartment',
          'apartment',
          'shared',
          'student',
          'townhouse'
        ].includes(
          a.homeType
        )
      ) {
        score += 3;
      }

      if (
        [
          'uncertain',
          'approval_needed'
        ].includes(
          a.housingStability
        )
      ) {
        score += 1;
      }

      if (
        [
          'none',
          'balcony',
          'supervised_only'
        ].includes(
          a.outdoorAccess
        )
      ) {
        score += 2;
      }

      if (
        [
          'lt15',
          '15_30',
          '30_60'
        ].includes(
          a.dailyTime
        )
      ) {
        score += 4;
      }

      if (
        [
          '6_8',
          '9_12',
          'variable'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 1;
      }

      if (
        [
          'very_calm',
          'calm_playful'
        ].includes(
          a.energyMatch
        )
      ) {
        score += 2;
      }

      if (
        [
          'homebody'
        ].includes(
          a.activityLifestyle
        )
      ) {
        score += 2;
      }

      if (
        [
          'basic',
          'moderate'
        ].includes(
          a.budget
        )
      ) {
        score += 1;
      }

      if (
        [
          'quiet',
          'independent'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 5;
      }

      if (
        a.bondStyle ===
        'quiet'
      ) {
        score += 2;
      }

      if (
        a.stressMost ===
        'exercise'
      ) {
        score += 2;
      }

      if (
        a.stressMost ===
        'cage_cleaning'
      ) {
        score -= 4;
      }

      return score;
    }

    scoreFosterFirst(a) {
      let score = 0;

      if (
        [
          'might_move',
          'approval_needed',
          'uncertain'
        ].includes(
          a.housingStability
        )
      ) {
        score += 4;
      }

      if (
        [
          'variable',
          'travel'
        ].includes(
          a.aloneTime
        )
      ) {
        score += 3;
      }

      if (
        [
          'basic',
          'moderate'
        ].includes(
          a.budget
        )
      ) {
        score += 1;
      }

      if (
        a.emergencyVet ===
          'maybe' ||
        a.emergencyVet ===
          'insurance'
      ) {
        score += 2;
      }

      if (
        [
          'family',
          'cuddly',
          'support',
          'balanced_bond'
        ].includes(
          a.bondStyle
        )
      ) {
        score += 1;
      }

      if (
        a.stressMost ===
          'time' ||
        a.stressMost ===
          'vet_bills'
      ) {
        score += 2;
      }

      return score;
    }

    scoreNotYet(a) {
      let score = 0;

      if (
        a.dailyTime ===
          'lt15' ||
        a.dailyTime ===
          '15_30'
      ) {
        score += 4;
      }

      if (
        a.aloneTime ===
        'travel'
      ) {
        score += 5;
      }

      if (
        a.aloneTime ===
        '9_12'
      ) {
        score += 3;
      }

      if (
        a.budget ===
        'very_limited'
      ) {
        score += 5;
      }

      if (
        a.emergencyVet ===
        'no'
      ) {
        score += 5;
      }

      if (
        [
          'approval_needed',
          'uncertain'
        ].includes(
          a.housingStability
        )
      ) {
        score += 4;
      }

      if (
        a.stressMost ===
          'time' ||
        a.stressMost ===
          'vet_bills'
      ) {
        score += 3;
      }

      if (
        a.stressMost ===
          'exercise' &&
        a.activityLifestyle ===
          'homebody'
      ) {
        score += 2;
      }

      if (
        a.allergies ===
        'severe'
      ) {
        score += 2;
      }

      return score;
    }

    inferDogSizePreference(a) {
      const scores = {
        small: 0,
        medium: 0,
        large: 0,
        extra_large: 0
      };

      if (
        [
          'small_apartment',
          'apartment',
          'shared',
          'student'
        ].includes(
          a.homeType
        )
      ) {
        scores.small += 3;
      }

      if (
        a.homeType ===
        'townhouse'
      ) {
        scores.small += 2;
      }

      if (
        a.homeType ===
        'small_yard'
      ) {
        scores.medium += 2;
      }

      if (
        a.homeType ===
        'large_yard'
      ) {
        scores.large += 3;
      }

      if (
        a.homeType ===
        'farm'
      ) {
        scores.extra_large +=
          3;
      }

      if (
        [
          'none',
          'balcony',
          'supervised_only'
        ].includes(
          a.outdoorAccess
        )
      ) {
        scores.small += 2;
      }

      if (
        a.outdoorAccess ===
        'small_secure'
      ) {
        scores.medium += 2;
      }

      if (
        a.outdoorAccess ===
        'large_secure'
      ) {
        scores.large += 2;
      }

      if (
        a.outdoorAccess ===
        'farm'
      ) {
        scores.extra_large +=
          2;
      }

      if (
        a.energyMatch ===
        'very_calm'
      ) {
        scores.small += 1;
      }

      if (
        a.energyMatch ===
        'calm_playful'
      ) {
        scores.small += 1;
      }

      if (
        a.energyMatch ===
        'balanced'
      ) {
        scores.medium += 1;
      }

      if (
        a.energyMatch ===
        'active'
      ) {
        scores.large += 1;
      }

      if (
        a.energyMatch ===
        'working'
      ) {
        scores.extra_large +=
          1;
      }

      if (
        a.dailyTime ===
        'lt15'
      ) {
        scores.small += 1;
      }

      if (
        a.dailyTime ===
        '15_30'
      ) {
        scores.small += 1;
      }

      if (
        a.dailyTime ===
        '30_60'
      ) {
        scores.medium += 1;
      }

      if (
        a.dailyTime ===
        '1_2'
      ) {
        scores.large += 1;
      }

      if (
        a.dailyTime ===
          '2_4' ||
        a.dailyTime ===
          '4_plus'
      ) {
        scores.extra_large +=
          1;
      }

      return this.getTopBreedSize(
        scores,
        this.dogBreedsData
      );
    }

    inferCatSizePreference(a) {
      const scores = {
        small: 0,
        medium: 0,
        large: 0
      };

      if (
        [
          'small_apartment',
          'apartment',
          'shared',
          'student'
        ].includes(
          a.homeType
        )
      ) {
        scores.small += 2;
      }

      if (
        [
          'townhouse',
          'small_yard'
        ].includes(
          a.homeType
        )
      ) {
        scores.medium += 2;
      }

      if (
        [
          'large_yard',
          'farm'
        ].includes(
          a.homeType
        )
      ) {
        scores.large += 1;
      }

      if (
        a.bondStyle ===
        'independent'
      ) {
        scores.medium += 1;
      }

      if (
        a.bondStyle ===
        'quiet'
      ) {
        scores.small += 1;
      }

      if (
        a.bondStyle ===
          'family' ||
        a.bondStyle ===
          'cuddly' ||
        a.bondStyle ===
          'balanced_bond'
      ) {
        scores.medium += 1;
      }

      if (
        a.dailyTime ===
        'lt15'
      ) {
        scores.small += 1;
      }

      if (
        a.dailyTime ===
        '15_30'
      ) {
        scores.small += 1;
      }

      if (
        a.dailyTime ===
        '30_60'
      ) {
        scores.medium += 1;
      }

      if (
        a.dailyTime ===
          '1_2' ||
        a.dailyTime ===
          '2_4' ||
        a.dailyTime ===
          '4_plus'
      ) {
        scores.large += 1;
      }

      return this.getTopBreedSize(
        scores,
        this.catBreedsData
      );
    }

    getTopBreedSize(
      sizeScores,
      breedsData
    ) {
      const availableSizes =
        Object.keys(
          breedsData || {}
        );

      const entries =
        Object.entries(
          sizeScores
        )
          .filter(
            ([size]) =>
              availableSizes.includes(
                size
              )
          )
          .sort(
            (
              left,
              right
            ) =>
              right[1] -
              left[1]
          );

      return entries.length
        ? entries[0][0]
        : '';
    }

    buildResultContent(
      resultKey,
      ranking
    ) {
      const a =
        this.state.answers;

      const meta =
        RESULT_META[
          resultKey
        ] ||
        RESULT_META.not_yet;

      const alsoSuitable =
        this.buildAlsoSuitable(
          ranking,
          resultKey
        );

      const avoidForNow =
        this.buildAvoidForNow(
          resultKey
        );

      const scoreLabel =
        this.buildScoreLabel(
          resultKey,
          ranking
        );

      return {
        label:
          meta.label,
        scoreLabel,
        summary:
          this.buildSummary(
            resultKey,
            meta,
            a
          ),
        why:
          this.buildWhyList(
            resultKey,
            a
          ),
        prepare:
          this.buildPrepareList(
            resultKey,
            a
          ),
        avoid:
          avoidForNow,
        also:
          alsoSuitable,
        appText:
          this.buildAppText(
            resultKey,
            meta
          ),
        appFeatures:
          this.buildAppFeatures(
            resultKey,
            meta
          ),
        productType:
          meta.productType
      };
    }

    buildScoreLabel(
      resultKey,
      ranking
    ) {
      const best =
        ranking[0]?.score ||
        0;

      const second =
        ranking[1]?.score ||
        0;

      const margin =
        best - second;

      if (
        resultKey ===
        'not_yet'
      ) {
        return 'Needs planning';
      }

      if (
        resultKey ===
        'foster_first'
      ) {
        return margin >= 4
          ? 'Very sensible option'
          : 'Smart first step';
      }

      if (
        margin >= 7
      ) {
        return 'Excellent match';
      }

      if (
        margin >= 4
      ) {
        return 'Strong match';
      }

      return 'Good match';
    }

    buildSummary(
      resultKey,
      meta,
      a
    ) {
      const homeCompact =
        [
          'small_apartment',
          'apartment',
          'shared',
          'student'
        ].includes(
          a.homeType
        );

      const stable =
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        );

      const lotsOfTime =
        [
          '2_4',
          '4_plus'
        ].includes(
          a.dailyTime
        );

      const limitedTime =
        [
          'lt15',
          '15_30'
        ].includes(
          a.dailyTime
        );

      const travelHeavy =
        [
          'travel',
          'variable'
        ].includes(
          a.aloneTime
        );

      const activeLifestyle =
        [
          'very_active',
          'training_lifestyle'
        ].includes(
          a.activityLifestyle
        );

      switch (
        resultKey
      ) {
        case 'adult_cat':
          return homeCompact
            ? 'An adult cat looks like a strong fit because your lifestyle seems to suit a companion that can be affectionate, manageable, and more independent than a high-demand pet.'
            : 'An adult cat looks like a strong fit because you seem to want companionship and emotional connection without the full day-to-day intensity of a puppy or highly demanding active pet.';

        case 'kitten':
          return lotsOfTime
            ? 'A kitten could suit you well because you appear to have enough time, flexibility, and emotional patience for a younger pet that needs setup, guidance, and a playful home.'
            : 'A kitten could suit you, but mainly because you seem open to a more playful, evolving companion and may be willing to handle the extra unpredictability that comes with early development.';

        case 'small_dog':
          return 'A small adult dog looks like a strong match because you seem to want affection, routine, and companionship, but in a form that is generally more manageable than a high-energy larger dog or a young puppy.';

        case 'family_dog':
          return 'A family-style dog looks like a good match because your answers suggest a home that can support a social, people-oriented companion with regular interaction, routine, and movement.';

        case 'active_dog':
          return activeLifestyle
            ? 'An active dog looks like one of the best matches for you because your lifestyle, expectations, and energy level suggest you would genuinely enjoy the responsibility of a more engaged and athletic companion.'
            : 'An active dog looks like a strong match because you seem to want a pet that feels like a real partner in daily life, not just a passive companion in the background.';

        case 'puppy':
          return stable &&
            lotsOfTime
            ? 'A puppy may genuinely suit you because your answers suggest enough time, commitment, and willingness to shape a pet from the beginning — including the harder early months.'
            : 'A puppy could suit you, but only because you seem open to a high-effort bond-building experience and may be willing to handle the messier, more demanding stages of pet ownership.';

        case 'small_pet':
          return 'A rabbit or guinea pig may suit you because you seem open to caring for a gentler, quieter companion without taking on the same daily exercise and training commitment that comes with many dogs.';

        case 'bird_reptile_fish':
          return 'A bird, reptile, or fish may suit you better because your answers suggest you may value beauty, routine, observation, or lower social intensity more than highly interactive pet ownership.';

        case 'foster_first':
          return travelHeavy ||
            !stable
            ? 'Fostering may be the smartest next step because your lifestyle still looks a little changeable, and a lower-commitment path could help you learn what truly fits before making a long-term decision.'
            : 'Fostering may be the smartest next step because you clearly care about animals, but your answers suggest that trying real-world pet care before committing long term would be a very sensible move.';

        case 'not_yet':
        default:
          return limitedTime
            ? 'Right now may not be the easiest moment to bring a pet home. That does not mean never — it simply suggests that time, budget, lifestyle, or stability may need a bit more preparation first.'
            : 'Right now may not be the easiest moment to bring a pet home. Your answers suggest there may be a few practical barriers that would be worth solving before taking on a long-term animal commitment.';
      }
    }

    buildWhyList(
      resultKey,
      a
    ) {
      const items = [];

      const add = (
        text
      ) => {
        if (
          text &&
          !items.includes(
            text
          )
        ) {
          items.push(
            text
          );
        }
      };

      const homeCompact =
        [
          'small_apartment',
          'apartment',
          'shared',
          'student'
        ].includes(
          a.homeType
        );

      const yard =
        [
          'small_yard',
          'large_yard',
          'farm'
        ].includes(
          a.homeType
        );

      const stable =
        [
          'very_stable',
          'mostly_stable'
        ].includes(
          a.housingStability
        );

      const lotsOfTime =
        [
          '1_2',
          '2_4',
          '4_plus'
        ].includes(
          a.dailyTime
        );

      const lowTime =
        [
          'lt15',
          '15_30'
        ].includes(
          a.dailyTime
        );

      const aloneLong =
        [
          '9_12',
          'travel'
        ].includes(
          a.aloneTime
        );

      const wantsCuddles =
        [
          'cuddly',
          'family',
          'support'
        ].includes(
          a.bondStyle
        );

      const wantsIndependence =
        [
          'independent',
          'quiet'
        ].includes(
          a.bondStyle
        );

      const wantsTraining =
        [
          'training',
          'exercise'
        ].includes(
          a.bondStyle
        );

      const activeLifestyle =
        [
          'daily_walks',
          'very_active',
          'training_lifestyle'
        ].includes(
          a.activityLifestyle
        );

      const quietLifestyle =
        [
          'homebody',
          'short_walks'
        ].includes(
          a.activityLifestyle
        );

      switch (
        resultKey
      ) {
        case 'adult_cat':
          if (
            homeCompact
          ) {
            add(
              'Your home setup looks compatible with a pet that can live well in a more compact indoor environment.'
            );
          }

          if (
            wantsIndependence
          ) {
            add(
              'You seem to appreciate a companion that can feel close without needing constant supervision or output.'
            );
          }

          if (
            !lowTime
          ) {
            add(
              'Your available time looks realistic for the daily care, enrichment, and monitoring a cat still needs.'
            );
          }

          if (
            quietLifestyle
          ) {
            add(
              'Your lifestyle suggests a calmer, lower-pressure bond may suit you well.'
            );
          }

          break;

        case 'kitten':
          if (
            lotsOfTime
          ) {
            add(
              'You appear to have enough time for a younger pet that needs more setup, supervision, and interaction.'
            );
          }

          if (
            wantsCuddles
          ) {
            add(
              'You seem to want a close bond, which often fits people drawn to raising a pet from the beginning.'
            );
          }

          add(
            'You seem open to a more playful, changing, and slightly chaotic early phase of pet ownership.'
          );

          if (
            stable
          ) {
            add(
              'Your living situation looks stable enough for the first important growth period.'
            );
          }

          break;

        case 'small_dog':
          if (
            wantsCuddles
          ) {
            add(
              'You seem to want a companion that feels socially present and emotionally rewarding.'
            );
          }

          if (
            !aloneLong
          ) {
            add(
              'Your schedule looks more realistic for a pet that benefits from regular human contact and routine.'
            );
          }

          if (
            yard ||
            homeCompact
          ) {
            add(
              'Your home setup could support a smaller dog more comfortably than a larger or more demanding one.'
            );
          }

          add(
            'A small adult dog can offer companionship without the full training intensity of a puppy.'
          );

          break;

        case 'family_dog':
          if (
            wantsCuddles
          ) {
            add(
              'Your answers suggest you want a social and emotionally present pet rather than a very independent one.'
            );
          }

          if (
            activeLifestyle ||
            lotsOfTime
          ) {
            add(
              'Your routine looks compatible with regular exercise, structure, and companionship.'
            );
          }

          if (
            [
              'children',
              'teens',
              'mixed'
            ].includes(
              a.household
            )
          ) {
            add(
              'Your household profile suggests a family-oriented pet could fit well.'
            );
          }

          if (
            yard
          ) {
            add(
              'Your home setup looks more suitable for a mid-sized social pet than a very restricted space would be.'
            );
          }

          break;

        case 'active_dog':
          if (
            activeLifestyle
          ) {
            add(
              'Your real lifestyle suggests you may actually enjoy the exercise and structure this type of pet needs.'
            );
          }

          if (
            wantsTraining
          ) {
            add(
              'You seem to want a pet that feels mentally engaging and interactive, not just decorative or passive.'
            );
          }

          if (
            lotsOfTime
          ) {
            add(
              'Your available time makes a more demanding companion much more realistic.'
            );
          }

          if (
            [
              'confident',
              'very_experienced',
              'challenge'
            ].includes(
              a.trainingConfidence
            )
          ) {
            add(
              'Your confidence around training makes a higher-drive pet more viable.'
            );
          }

          break;

        case 'puppy':
          if (
            lotsOfTime
          ) {
            add(
              'You seem to have enough day-to-day time for a pet that needs training, repetition, and patience.'
            );
          }

          if (
            stable
          ) {
            add(
              'A stable home setup makes the early puppy stage much more manageable.'
            );
          }

          if (
            [
              'some',
              'confident',
              'very_experienced',
              'challenge'
            ].includes(
              a.trainingConfidence
            )
          ) {
            add(
              'You seem reasonably prepared for boundaries, routine, and behaviour shaping.'
            );
          }

          add(
            'You appear open to building a bond from the beginning, not just adopting a finished personality.'
          );

          break;

        case 'small_pet':
          if (
            quietLifestyle
          ) {
            add(
              'You do not seem to need a highly intense or highly social animal to feel satisfied.'
            );
          }

          if (
            wantsIndependence
          ) {
            add(
              'You appear comfortable with a pet relationship that is gentler and less all-consuming.'
            );
          }

          if (
            !lowTime
          ) {
            add(
              'Your time looks sufficient for daily care without requiring a dog-level exercise routine.'
            );
          }

          add(
            'A smaller companion may suit your lifestyle better than a very demanding household pet.'
          );

          break;

        case 'bird_reptile_fish':
          if (
            wantsIndependence
          ) {
            add(
              'You seem more open to a pet that is interesting, beautiful, or calming without constant contact.'
            );
          }

          if (
            lowTime ||
            quietLifestyle
          ) {
            add(
              'Your lifestyle may fit observation-based care better than a highly interactive pet.'
            );
          }

          add(
            'A habitat-based pet can sometimes suit people who want routine and care without a large social burden.'
          );

          break;

        case 'foster_first':
          if (
            !stable
          ) {
            add(
              'Your answers suggest your living situation may still be changing.'
            );
          }

          if (
            aloneLong
          ) {
            add(
              'Your schedule may make a permanent commitment harder to manage confidently right now.'
            );
          }

          add(
            'Fostering would still let you care for animals and gain real experience.'
          );

          add(
            'It could help you learn what genuinely fits before committing for many years.'
          );

          break;

        case 'not_yet':
        default:
          if (
            lowTime
          ) {
            add(
              'Your available daily time looks quite tight for most pets.'
            );
          }

          if (
            a.budget ===
              'very_limited' ||
            a.emergencyVet ===
              'no'
          ) {
            add(
              'The financial side of pet ownership may feel too fragile right now.'
            );
          }

          if (
            !stable
          ) {
            add(
              'Your housing or life setup may need a little more stability first.'
            );
          }

          add(
            'Thinking honestly now can prevent a stressful mismatch later.'
          );

          break;
      }

      const fallbackReasons = [
        'Your answers show you are thinking practically about what pet ownership would really involve.',
        'Your preferences suggest that day-to-day manageability is an important part of finding the right match.',
        'Your home, routine, and expectations all play an important role in making this recommendation realistic.',
        'This match aims to balance companionship with the level of care you can comfortably provide.'
      ];

      for (
        const reason of
        fallbackReasons
      ) {
        if (
          items.length >= 4
        ) {
          break;
        }

        add(reason);
      }

      return items.slice(
        0,
        4
      );
    }

    buildPrepareList(
      resultKey,
      a
    ) {
      const items = [];

      const add = (
        text
      ) => {
        if (
          text &&
          !items.includes(
            text
          )
        ) {
          items.push(
            text
          );
        }
      };

      switch (
        resultKey
      ) {
        case 'adult_cat':
          add(
            'Plan for litter management, scratching options, enrichment, and a secure indoor setup.'
          );

          add(
            'Budget for vaccinations, parasite prevention, and ongoing routine vet care.'
          );

          add(
            'Think about how you would handle travel, holidays, and changes in daily routine.'
          );

          add(
            'Be ready to monitor appetite, litter habits, behaviour, and long-term health trends.'
          );

          break;

        case 'kitten':
          add(
            'Prepare for scratching, climbing, playful chaos, and a more hands-on early phase.'
          );

          add(
            'Set up vaccination, parasite prevention, and safe indoor routines from the start.'
          );

          add(
            'Expect the personality to develop over time rather than feel fully predictable right away.'
          );

          add(
            'Create a home environment that is safe, enriching, and easy to supervise.'
          );

          break;

        case 'small_dog':
          add(
            'Prepare for walks, routine, training, and emotional attachment — even with a smaller pet.'
          );

          add(
            'Budget for grooming, dental care, parasite prevention, and unexpected vet needs.'
          );

          add(
            'Think about noise, alone time, and whether neighbours or shared walls could matter.'
          );

          add(
            'Be realistic about consistency: smaller dogs still need boundaries and structure.'
          );

          break;

        case 'family_dog':
          add(
            'Prepare for daily exercise, social structure, and training consistency.'
          );

          add(
            'Make sure everyone in the home would respond to the dog in a consistent way.'
          );

          add(
            'Budget for food, grooming, parasite prevention, and routine health care.'
          );

          add(
            'Think about holidays, visitors, excitement, and long-term household routines.'
          );

          break;

        case 'active_dog':
          add(
            'Prepare for a pet that will need both physical exercise and mental stimulation every week.'
          );

          add(
            'Think beyond walks — training, enrichment, and structured outlets will matter.'
          );

          add(
            'Secure space, gear, recall, safety, and injury awareness become more important here.'
          );

          add(
            'Be realistic about what happens on busy days, bad-weather days, or travel weeks.'
          );

          break;

        case 'puppy':
          add(
            'Prepare for toilet training, chewing, interrupted routines, and constant repetition.'
          );

          add(
            'The early months will require patience, supervision, and a lot of consistency.'
          );

          add(
            'Budget for vaccinations, parasite prevention, training support, and growth-stage care.'
          );

          add(
            'Expect the first phase to be adorable, but also exhausting and very hands-on.'
          );

          break;

        case 'small_pet':
          add(
            'Prepare for habitat setup, food management, cleaning, and species-specific needs.'
          );

          add(
            'Do not underestimate dental care, weight monitoring, and subtle signs of illness.'
          );

          add(
            'A smaller pet can still need daily care and careful observation.'
          );

          add(
            'Make sure the environment is safe from stress, heat, predators, and handling mistakes.'
          );

          break;

        case 'bird_reptile_fish':
          add(
            'The setup matters as much as the animal — habitat quality is a huge part of success.'
          );

          add(
            'Expect ongoing cleaning, environmental monitoring, and species-specific routines.'
          );

          add(
            'Research lighting, temperature, space, enrichment, and nutrition carefully.'
          );

          add(
            'These pets may be quieter, but they still require consistency and informed care.'
          );

          break;

        case 'foster_first':
          add(
            'Use fostering to test your routines, boundaries, and actual capacity in real life.'
          );

          add(
            'Choose a setup where support, advice, and handover expectations are clear.'
          );

          add(
            'Treat it as learning, not failure — it is a smart preparation stage.'
          );

          add(
            'Pay attention to what feels energising versus draining during the foster period.'
          );

          break;

        case 'not_yet':
        default:
          add(
            'Work on time, budget, housing confidence, or support systems before adopting.'
          );

          add(
            'Research the day-to-day reality of the pets you are most drawn to.'
          );

          add(
            'Consider volunteering, pet sitting, or fostering as a lower-risk next step.'
          );

          add(
            'A little preparation now can protect both you and a future pet from a poor match.'
          );

          break;
      }

      if (
        a.stressMost ===
        'vet_bills'
      ) {
        add(
          'Make a plan for emergency care before committing.'
        );
      }

      if (
        a.stressMost ===
        'noise'
      ) {
        add(
          'Think carefully about noise tolerance, neighbours, and household sensitivity.'
        );
      }

      if (
        a.stressMost ===
        'mess'
      ) {
        add(
          'Be honest about how much cleaning and fur or litter you can handle long term.'
        );
      }

      if (
        a.stressMost ===
        'time'
      ) {
        add(
          'Protect your routine first — pets do best when care is predictable.'
        );
      }

      return items.slice(
        0,
        4
      );
    }

    buildAvoidForNow(
      resultKey
    ) {
      const suggestions = {
        adult_cat:
          'Puppy, highly driven working dog, or very noisy pet may feel like too much right now.',
        kitten:
          'A puppy or very high-drive active dog may still demand more structure than you want.',
        small_dog:
          'A puppy or high-drive larger dog may feel more intense than your ideal match.',
        family_dog:
          'A very high-drive working dog or very low-engagement pet may be a weaker fit.',
        active_dog:
          'A very passive or low-engagement pet may not match what you are looking for emotionally.',
        puppy:
          'A high-uncertainty commitment would be risky if your routine changes often.',
        small_pet:
          'A very high-energy dog may ask for more lifestyle change than you want.',
        bird_reptile_fish:
          'A puppy or highly social active dog may feel far more demanding than your preferences suggest.',
        foster_first:
          'A long-lifespan, high-need pet may be too much to commit to immediately.',
        not_yet:
          'A puppy, active dog, or any high-maintenance pet is probably not ideal right now.'
      };

      return (
        suggestions[
          resultKey
        ] ||
        suggestions.not_yet
      );
    }

    buildAlsoSuitable(
      ranking,
      bestKey
    ) {
      const alternatives =
        ranking
          .filter(
            (item) =>
              item.key !==
                bestKey &&
              item.key !==
                'not_yet'
          )
          .slice(
            0,
            2
          )
          .map(
            (item) =>
              RESULT_META[
                item.key
              ]?.label
          )
          .filter(Boolean);

      if (
        bestKey ===
        'not_yet'
      ) {
        return 'Foster First';
      }

      return (
        alternatives.join(
          ', '
        ) ||
        'None strongly above the rest'
      );
    }

    buildAppText(
      resultKey,
      meta
    ) {
      const texts = {
        cat:
          'Download ASK A VET™ to build your cat plan, store health records, track appetite, behaviour, routine changes, and get support when questions come up.',
        dog:
          'Download ASK A VET™ to build your dog profile, manage records and reminders, track weight, stool, vomiting, behaviour, and get support early.',
        small_pet:
          'Use ASK A VET™ to organise reminders, notes, feeding patterns, weight, medication, and care observations in one place.',
        other:
          'Use ASK A VET™ to organise reminders, planning notes, and practical care questions before or after bringing a pet home.'
      };

      if (
        resultKey ===
        'foster_first'
      ) {
        return 'ASK A VET™ can also support fostering by helping you track temporary care notes, reminders, and observations in one simple place.';
      }

      if (
        resultKey ===
        'not_yet'
      ) {
        return 'ASK A VET™ can still help you prepare by organising research, questions, reminders, and future pet planning before you commit.';
      }

      return (
        texts[
          meta.species
        ] ||
        texts.other
      );
    }

    buildAppFeatures(
      resultKey,
      meta
    ) {
      if (
        resultKey ===
        'not_yet'
      ) {
        return [
          'Future pet planning',
          'Care research notes',
          'Reminder planning',
          'Vet questions'
        ];
      }

      if (
        resultKey ===
        'foster_first'
      ) {
        return [
          'Temporary pet profiles',
          'Health notes',
          'Medication reminders',
          'Weight tracking'
        ];
      }

      if (
        meta.species ===
        'cat'
      ) {
        return [
          'Create cat profile',
          'Vaccination reminders',
          'Parasite reminders',
          'Weight tracking',
          'Behaviour logs'
        ];
      }

      if (
        meta.species ===
        'dog'
      ) {
        return [
          'Create dog profile',
          'Vaccination reminders',
          'Parasite reminders',
          'Weight tracking',
          'Behaviour logs'
        ];
      }

      return [
        'Profile setup',
        'Care reminders',
        'Health notes',
        'Medication logs'
      ];
    }

    renderProducts(
      result
    ) {
      if (
        !this.productsCard ||
        !this.productsText ||
        !this.productsLink
      ) {
        return;
      }

      const dogUrl =
        this.dataset
          .dogCollectionUrl;

      const catUrl =
        this.dataset
          .catCollectionUrl;

      this.productsCard.hidden =
        true;

      this.productsText.textContent =
        '';

      this.productsLink.hidden =
        true;

      this.productsLink.href =
        '#';

      this.productsLink.textContent =
        'Explore products';

      this.productsLink.onclick =
        null;

      if (
        result.productType ===
          'dog' &&
        dogUrl
      ) {
        this.productsCard.hidden =
          false;

        this.productsText.textContent =
          'Explore WOOPF™ dog products, ASK A VET™ ID tags, and tracker-ready next steps for your future dog.';

        this.productsLink.hidden =
          false;

        this.productsLink.href =
          dogUrl;

        this.productsLink.textContent =
          'Explore dog products';

        this.productsLink.onclick =
          () => {
            this.trackEvent(
              'woopf_clicked',
              {
                result:
                  this.state
                    .resultKey
              }
            );
          };

        return;
      }

      if (
        result.productType ===
          'cat' &&
        catUrl
      ) {
        this.productsCard.hidden =
          false;

        this.productsText.textContent =
          'Explore PURRZ™ cat products and setup essentials for your future cat.';

        this.productsLink.hidden =
          false;

        this.productsLink.href =
          catUrl;

        this.productsLink.textContent =
          'Explore cat products';

        this.productsLink.onclick =
          () => {
            this.trackEvent(
              'purrz_clicked',
              {
                result:
                  this.state
                    .resultKey
              }
            );
          };
      }
    }

    updateUrlWithResult(
      resultKey
    ) {
      try {
        const url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          'pet_match',
          resultKey
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      } catch (
        error
      ) {
        console.warn(
          '[Perfect Pet Picker] Could not update URL',
          error
        );
      }
    }

    clearResultUrlParam() {
      try {
        const url =
          new URL(
            window.location.href
          );

        url.searchParams.delete(
          'pet_match'
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      } catch (
        error
      ) {
        console.warn(
          '[Perfect Pet Picker] Could not clear URL param',
          error
        );
      }
    }

    openModal() {
      if (
        !this.modal
      ) {
        return;
      }

      this.modal.classList.add(
        'is-open'
      );

      this.modal.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'modal-open'
      );

      document.removeEventListener(
        'keydown',
        this.onKeydown
      );

      document.addEventListener(
        'keydown',
        this.onKeydown
      );

      const closeButton =
        this.modal.querySelector(
          '.perfect-pet-picker__modal-close'
        );

      closeButton?.focus({
        preventScroll:
          true
      });
    }

    closeModal({
      resetUrl = true
    } = {}) {
      if (
        !this.modal
      ) {
        return;
      }

      this.modal.classList.remove(
        'is-open'
      );

      this.modal.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'modal-open'
      );

      document.removeEventListener(
        'keydown',
        this.onKeydown
      );

      if (
        resetUrl
      ) {
        this.clearResultUrlParam();
      }

      this.resetCopyButton();
    }

    goBackToAnswers() {
      this.abortActiveRequest();

      this.closeModal({
        resetUrl: true
      });

      this.setVisibleStep(
        'quiz'
      );

      this.renderQuestion();

      this.trackEvent(
        'result_edited',
        {
          result:
            this.state
              .resultKey
        }
      );
    }

    restartQuiz() {
      this.abortActiveRequest();

      this.closeModal({
        resetUrl: true
      });

      this.state.currentIndex =
        0;

      this.state.answers =
        {};

      this.state.resultKey =
        null;

      this.setLoading(
        false
      );

      this.clearRenderedResult();

      this.setVisibleStep(
        'welcome'
      );

      this.trackEvent(
        'quiz_restarted'
      );
    }

    clearRenderedResult() {
      if (
        this.resultTitle
      ) {
        this.resultTitle.textContent =
          '';
      }

      if (
        this.resultSummary
      ) {
        this.resultSummary.textContent =
          '';
      }

      if (
        this.resultScore
      ) {
        this.resultScore.textContent =
          '';
      }

      if (
        this.resultScoreLabel
      ) {
        this.resultScoreLabel.textContent =
          '';
      }

      if (
        this.resultWhy
      ) {
        this.resultWhy.innerHTML =
          '';
      }

      if (
        this.resultPrepare
      ) {
        this.resultPrepare.innerHTML =
          '';
      }

      if (
        this.resultAvoid
      ) {
        this.resultAvoid.textContent =
          '';
      }

      if (
        this.resultAlso
      ) {
        this.resultAlso.textContent =
          '';
      }

      if (
        this.resultAppText
      ) {
        this.resultAppText.textContent =
          '';
      }

      if (
        this.resultAppFeatures
      ) {
        this.resultAppFeatures.innerHTML =
          '';
      }

      if (
        this.productsCard
      ) {
        this.productsCard.hidden =
          true;
      }

      if (
        this.productsText
      ) {
        this.productsText.textContent =
          '';
      }

      if (
        this.productsLink
      ) {
        this.productsLink.hidden =
          true;

        this.productsLink.href =
          '#';

        this.productsLink.textContent =
          'Explore products';

        this.productsLink.onclick =
          null;
      }

      if (
        this.resultPrimaryCta
      ) {
        this.resultPrimaryCta.href =
          '#';

        this.resultPrimaryCta.textContent =
          '';

        this.resultPrimaryCta.onclick =
          null;
      }
    }

    onKeydown(event) {
      if (
        event.key ===
        'Escape'
      ) {
        this.closeModal({
          resetUrl: true
        });
      }
    }

    resetCopyButton() {
      if (
        !this.copyResultLinkButton
      ) {
        return;
      }

      this.copyResultLinkButton.textContent =
        'Copy link';
    }

    async copyResultLink() {
      const link =
        window.location.href;

      try {
        if (
          navigator.clipboard &&
          typeof navigator
            .clipboard
            .writeText ===
            'function'
        ) {
          await navigator.clipboard.writeText(
            link
          );
        } else {
          this.copyTextFallback(
            link
          );
        }

        this.trackEvent(
          'result_shared',
          {
            result:
              this.state
                .resultKey,
            method:
              'copy_link'
          }
        );

        if (
          this.copyResultLinkButton
        ) {
          this.copyResultLinkButton.textContent =
            'Copied';
        }

        window.setTimeout(
          () => {
            this.resetCopyButton();
          },
          1500
        );
      } catch (
        error
      ) {
        console.warn(
          '[Perfect Pet Picker] Copy failed',
          error
        );

        if (
          this.copyResultLinkButton
        ) {
          this.copyResultLinkButton.textContent =
            'Copy failed';

          window.setTimeout(
            () => {
              this.resetCopyButton();
            },
            1500
          );
        }
      }
    }

    copyTextFallback(
      value
    ) {
      const textarea =
        document.createElement(
          'textarea'
        );

      textarea.value =
        value;

      textarea.setAttribute(
        'readonly',
        ''
      );

      textarea.style.position =
        'fixed';

      textarea.style.opacity =
        '0';

      textarea.style.pointerEvents =
        'none';

      document.body.appendChild(
        textarea
      );

      textarea.select();

      const copied =
        document.execCommand(
          'copy'
        );

      textarea.remove();

      if (
        !copied
      ) {
        throw new Error(
          'Browser copy command failed'
        );
      }
    }

    trackEvent(
      eventName,
      payload = {}
    ) {
      if (
        typeof window.gtag ===
        'function'
      ) {
        window.gtag(
          'event',
          eventName,
          payload
        );
      }

      if (
        typeof window.fbq ===
        'function'
      ) {
        window.fbq(
          'trackCustom',
          eventName,
          payload
        );
      }

      window.dataLayer =
        window.dataLayer ||
        [];

      window.dataLayer.push({
        event:
          eventName,
        perfect_pet_picker:
          payload
      });
    }

    escapeHtml(value) {
      return String(
        value || ''
      )
        .replaceAll(
          '&',
          '&amp;'
        )
        .replaceAll(
          '<',
          '&lt;'
        )
        .replaceAll(
          '>',
          '&gt;'
        )
        .replaceAll(
          '"',
          '&quot;'
        )
        .replaceAll(
          "'",
          '&#039;'
        );
    }
  }

  if (
    !customElements.get(
      's-perfect-pet-picker'
    )
  ) {
    customElements.define(
      's-perfect-pet-picker',
      SPerfectPetPicker
    );
  }
})();
